// Import all tab components
import ProductTab from '../components/tabs/ProductTab';
import ProductTabVariant from '../components/tabs/ProductTabVariant';
import TextTab from '../components/tabs/TextTab';
import StickersTab from '../components/tabs/StickersTab';
import UploadTab from '../components/tabs/UploadTab';
import BackgroundTab from '../components/tabs/BackgroundTab';
import ToolboxTab from '../components/tabs/ToolboxTab';

// Import React icons
import { BiPackage, BiText, BiSticker, BiUpload, BiPalette, BiWrench } from 'react-icons/bi';

const tabsConfig = [
  { 
    id: 'product', 
    icon: BiPackage, 
    label: 'product.title',
    title: 'product.title',
    description: 'Customize your product settings and details.',
    showInNavbar: true,
    showInSidebar: true,
    component: ProductTabVariant
  },
  { 
    id: 'upload', 
    icon: BiUpload, 
    label: 'upload.title',
    title: 'upload.title',
    description: 'Upload images and other assets to your design.',
    showInNavbar: true,
    showInSidebar: true,
    component: UploadTab
  },
  { 
    id: 'stickers', 
    icon: BiSticker, 
    label: 'stickers.title',
    title: 'stickers.title',
    description: 'Choose from our collection of stickers.',
    showInNavbar: true,
    showInSidebar: true,
    allowStickerTabThemeSelection: false,
    component: StickersTab
  },
  { 
    id: 'text', 
    icon: BiText, 
    label: 'text.title',
    title: 'text.title',
    description: 'Customize and add text to your design.',
    showInNavbar: true,
    showInSidebar: true,
    component: TextTab
  },
  { 
    id: 'background', 
    icon: BiPalette, 
    label: 'background.title',
    title: 'background.title',
    description: 'Customize the background color and patterns.',
    showInNavbar: true,
    showInSidebar: true,
    component: BackgroundTab
  },
  { 
    id: 'toolbox', 
    icon: BiWrench, 
    label: 'toolbox.title',
    title: 'toolbox.title',
    description: 'Quick tools and actions.',
    showInNavbar: false,
    showInSidebar: false,
    component: ToolboxTab
  },
];

// Create a map of tab IDs to their components
export const tabComponents = tabsConfig.reduce((acc, tab) => {
  acc[tab.id] = tab.component;
  return acc;
}, {});

export default tabsConfig;
